import { Box, Typography } from "@mui/material";
import { useTranslation, Trans } from "react-i18next";
import { partners } from "../assets";

export default function StrategicPartners() {
  const { t } = useTranslation();

  return (
    <Box component="section" sx={{ bgcolor: "#ECEDF8" }}>
      <Box
        sx={{
          width: { xs: "100%", lg: "1440px" },
          mx: "auto",
          py: { xs: 6, md: 8 },
        }}
      >
        <Box sx={{ width: { xs: "100%", lg: "1248px" }, mx: "auto", px: { xs: 2, sm: 3 } }}>
          {/* Título com <bold> vindo do JSON */}
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: 18, md: 20, lg: 26 },
              lineHeight: 1.1,
              fontWeight: 500,
              textAlign: "center",
              color: "#0f1011",
              mb: { xs: 4, md: 5 },
            }}
          >
            <Trans
              i18nKey="partners.title"
              components={{
                bold: <Box key="bold" component="span" sx={{ fontWeight: 800 }} />,
              }}
            />
          </Typography>

          {/* Logos */}
          <Box
            sx={{
              width: "100%",
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(2, minmax(140px, 1fr))",
                md: "repeat(4, minmax(160px, 1fr))",
                lg: "repeat(4, 220px)",
              },
              justifyContent: { lg: "space-between" },
              gap: { xs: 3, md: 4 },
              mb: { xs: 4, md: 5 },
            }}
          >
            {[
              { src: partners.logoAlmap, alt: "AlmapBBDO" },
              { src: partners.logoAlexa, alt: "Alexa" },
              { src: partners.logoAWS, alt: "AWS" },
              { src: partners.logoGoogleCloud, alt: "Google Cloud" },
            ].map((item, i) => (
              <Box
                key={i}
                sx={{
                  width: { lg: "220px" },
                  height: { lg: "122.22px" },
                  aspectRatio: { xs: "16 / 9", lg: "220 / 122.22" },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                }}
              >
                <Box
                  component="img"
                  src={item.src}
                  alt={item.alt}
                  sx={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    userSelect: "none",
                    pointerEvents: "none",
                  }}
                />
              </Box>
            ))}
          </Box>

          {/* Descrição */}
          <Typography
            sx={{
              fontSize: { xs: 18, md: 20, lg: 26 },
              lineHeight: { xs: 1.5, lg: 1.6 },
              textAlign: "center",
              color: "#0f1011",
              opacity: 0.9,
              maxWidth: "1248px",
              mx: "auto",
            }}
          >
            {t("partners.desc")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}